import { render, staticRenderFns } from "./Self_employed.vue?vue&type=template&id=e5af845a&scoped=true"
import script from "./Self_employed.vue?vue&type=script&lang=js"
export * from "./Self_employed.vue?vue&type=script&lang=js"
import style0 from "./Self_employed.vue?vue&type=style&index=0&id=e5af845a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5af845a",
  null
  
)

export default component.exports